import { FaAws, FaGithub, FaNodeJs, FaReact, FaRegCheckCircle } from "react-icons/fa";

import { RiFirebaseLine, RiNextjsLine, RiTailwindCssFill } from "react-icons/ri";
import { SiAxios, SiExpress, SiGraphql, SiJest, SiMongodb, SiMui, SiPuppeteer, SiRedux, SiShadcnui, SiSocketdotio } from "react-icons/si";
import { TbApi, TbBrandJavascript, TbBrandReactNative, TbBrandThreejs } from "react-icons/tb";
import { TbBrandTypescript } from "react-icons/tb"
import { PiNoteBlank } from "react-icons/pi";
import { BsFiletypeScss } from "react-icons/bs";


let skills;

export default skills = {
    frontend_web: [
        ["Next.js", "85%"],
        ["React", "80%"],
        ["Tailwind", "65%"],
        ["Zustand", "80%"],
        ["Jest", "60%"],
        ["Framer Motion", "85%"],
        ["Three.js", "65%"],
        ["jQuery", "80%"],
        ["TypeScript", "70%"],
        ["JavaScript", "75%"],
        ["React    Native", "65%"],
    ],
    backend_web: [
        ["Nodejs", "60%"],
        ["Express.js", "80%"],
        ["Mongoose", "90%"],
        ["Axios", "95%"],
        ["Socket.io", "85%"],
        ["Node-cron", "85%"],
        ["Firebase", "70%"],
        ["GraphQL", "75%"],
        ["Nodemailer", "90%"],
        ["JWT,OAuth", "85%"],
        ["Web scrapping", "85%"],
    ],
    app: [
        ["Flutter", "70%"],
        ["React Native", "75%"],
        ["Dart", "70%"],
        ["JavaScript", "75%"],
        ["Location", "95%"],
        ["Riverpod", "85%"],
        ["Dio", "90%"],
        ["rxdart", "95%"],
        ["NativeBase", "75%"],
        ["Lottie", "65%"],
        ["Detox", "85%"],
        ["Enzyme", "85%"],
    ],
    Others: [
        ["Lynx", "50%"],
        ["Git & GitHub", "65%"],
        ["AI API", "70%"],
        ["Writing", "60%"],
        ["Communication", "90%"],
        ["Creativity", "95%"],
        ["Decision making", "65%"],
        ["Problem solving", "85%"],
        ["Teamwork", "80%"],
        ["Leadership", "60%"],
        ["Time management", "90%"],
    ],
    tech: [
        {
            icon: <FaReact className="home_center_icon" />, name: "React"
        },
        {
            icon: <RiNextjsLine className="home_center_icon" />, name: "NextJs"
        },
        {
            icon: <RiTailwindCssFill className="home_center_icon" />, name: "Tailwind"
        },
        {
            icon: <SiRedux className="home_center_icon" />, name: "Redux"
        },
        {
            icon: <TbBrandJavascript className="home_center_icon" />, name: "JavaScript"
        },
        {
            icon: <TbBrandTypescript className="home_center_icon" />, name: "TypeScript"
        },
        {
            icon: <FaNodeJs className="home_center_icon" />, name: "Node.js"
        },
        {
            icon: <SiExpress className="home_center_icon" />, name: "Express.js"
        },
        {
            icon: <SiAxios className="home_center_icon" />, name: "Axios"
        },
        {
            icon: <SiSocketdotio className="home_center_icon" />, name: "Socket.io"
        },
        {
            icon: <RiFirebaseLine className="home_center_icon" />, name: "Firebase"
        },
        {
            icon: <SiGraphql className="home_center_icon" />, name: "GraphQL"
        },
        {
            icon: <TbBrandReactNative className="home_center_icon" />, name: "React Native"
        },
        {
            icon: <PiNoteBlank className="home_center_icon" />, name: "Lynx"
        },
        {
            icon: <PiNoteBlank className="home_center_icon" />, name: "Zustand"
        },
        {
            icon: <FaAws className="home_center_icon" />, name: "AWS"
        },
        {
            icon: <SiMongodb className="home_center_icon" />, name: "MongoDB"
        },
        {
            icon: <BsFiletypeScss className="home_center_icon" />, name: "SCSS"
        },
        {
            icon: <SiMui  className="home_center_icon" />, name: "MUI"
        },
        {
            icon: <SiShadcnui  className="home_center_icon" />, name: "Shadcn"
        },
        {
            icon: <SiJest className="home_center_icon" />, name: "Jest"
        },
        {
            icon: <TbBrandThreejs  className="home_center_icon" />, name: "Three.js"
        },
        {
            icon: <TbApi className="home_center_icon" />, name: "Integrations"
        },
        {
            icon: <SiPuppeteer className="home_center_icon" />, name: "Puppeteer"
        },
        {
            icon: <FaGithub className="home_center_icon" />, name: "Git & GitHub"
        },
    ],
    soft: [
        { name: "Writing", icon: <FaRegCheckCircle className="home_center_icon" /> },
        { name: "Communication", icon: <FaRegCheckCircle className="home_center_icon" /> },
        { name: "Problem Solving", icon: <FaRegCheckCircle className="home_center_icon" /> },
        { name: "Teamwork", icon: <FaRegCheckCircle className="home_center_icon" /> },
        { name: "Creativity", icon: <FaRegCheckCircle className="home_center_icon" /> },
        { name: "Adaptability", icon: <FaRegCheckCircle className="home_center_icon" /> },
        { name: "Decision Making", icon: <FaRegCheckCircle className="home_center_icon" /> },
        { name: "Time Management", icon: <FaRegCheckCircle className="home_center_icon" /> },
        { name: "Agile Methodology", icon: <FaRegCheckCircle className="home_center_icon" /> }
    ]
}

